import React, { useState } from "react";
import { Eye, EyeOff, Lock } from "lucide-react";

// Reusable password input with a show/hide eye toggle.
export const PasswordField = ({ value, onChange, placeholder = "Password", testId = "password-input", icon = true, required = true, className = "" }) => {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative flex items-center border border-black/15 focus-within:border-taven-gold ${className}`}>
      {icon && <Lock className="w-4 h-4 text-black/40 ml-4 shrink-0" />}
      <input
        required={required}
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        data-testid={testId}
        className={`w-full bg-transparent outline-none py-3.5 text-sm ${icon ? "px-3" : "px-4"}`}
      />
      <button type="button" onClick={() => setShow((s) => !s)} data-testid={`${testId}-toggle`}
        aria-label={show ? "Hide password" : "Show password"}
        className="px-4 text-black/40 hover:text-black shrink-0">
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
};

export default PasswordField;
